import * as React from 'react';

import { CarouselCardModel } from 'models';

import { UitkCard, UitkCardImageLayout, UitkCardLink } from 'uitk-react-cards';

import { CarouselCardContent } from './carousel-card-content';
import { CarouselCardImage } from './carousel-card-image';
import { CarouselCardLink } from './carousel-card-link';

export const CarouselCard: React.FunctionComponent<CarouselCardModel> = props => {
  if (Object.keys(props).length === 0) {
    return null;
  }

  return (
    <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED}>
      <CarouselCardImage {...props.image} />
      <CarouselCardContent {...props} />
      <CarouselCardLink linkComponent={UitkCardLink} linkModel={props.actionLink} />
    </UitkCard>
  );
};
